import React, { useEffect } from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { connect } from 'react-redux';
import * as common from '../../appRedux/actions/common';
import LoginImage from '../../assets/images/login.png';
import * as login from '../../appRedux/actions/login';
import * as field from '../../appRedux/actions/field';
import IntlMessages from '../../util/IntlMessages';
import { getVersion } from '../../util/tools';
import * as router from '../../constants/router';
import useStyles from './styles';

function LoginPage(props) {
  const classes = useStyles();
  const onChangeHandler = (data, field) => props.setFields([{ data, field }]);

  useEffect(() => {
    if (props.loginStatus) props.redirectAction(router.HOME);
  }, []);

  return (
    <React.Fragment>
      <Grid className={classes.root}>
        <Grid className={classes.gridImage}>
          <img
            src={LoginImage}
            alt={<IntlMessages id="alt.main" />}
            className={classes.image}
          />
        </Grid>
        <Typography variant="h5">
          <IntlMessages id="loginToPidoRefuelingApplication" />
        </Typography>
        <Grid>
          <TextField
            value={props.mobile}
            onChange={(e) => onChangeHandler(e.target.value, 'mobile')}
            autoFocus
            margin="normal"
            type="number"
            fullWidth
            label={<IntlMessages id="mobile" />}
            variant="filled"
          />
          <TextField
            onChange={(e) => onChangeHandler(e.target.value, 'password')}
            value={props.password}
            fullWidth
            type="password"
            label={<IntlMessages id="password" />}
            variant="filled"
          />
        </Grid>
        <LoadingButton
          onClick={() => props.operatorLoginAction()}
          loading={props.loadingBtn}
          variant="contained"
          fullWidth
          size="large"
          color="primary"
        >
          <IntlMessages id="login" />
        </LoadingButton>
        <Typography className={classes.version} variant="body2">
          <IntlMessages id="version" /> {' : ' + getVersion()}
        </Typography>
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    mobile: state.field.mobile,
    password: state.field.password,
    loadingBtn: state.common.loadingBtn,
    loginStatus: state.config.loginStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFields: (data) => dispatch(field.setFields(data)),
    redirectAction: (data) => dispatch(common.redirectAction(data)),
    operatorLoginAction: () => dispatch(login.operatorLoginAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
